<script setup lang="ts">
import { type Media } from './types';

interface Props {
	media: Media[];
	index: number;
}
const props = defineProps<Props>();
</script>

<template>
	<div
		class="rounded-4xl absolute top-md left-[3.25rem] bg-black/40 py-xxs px-md h-5xl flex items-center"
	>
		<span class="text-white text-xs"
			>{{ props.index + 1 }}/{{ props.media.length }}</span
		>
	</div>
</template>
